import type { AircraftBufferKey } from '@/lib/api/custodian';
import type { InventoryDrone } from '@/lib/api/types';

/** Which of an aircraft's buffers the operator emptied (ENG-295).
 *
 *  A value typed into a buffer box is saved with the rest of the config
 *  (`PUT /config`); an emptied box has to be sent as its own request, because
 *  `/config` reads null as "leave unchanged". An empty box over a buffer that
 *  was never set is nothing to do, and a buffer the backend does not carry
 *  (`undefined`) is read-only, so it can never be cleared. */
export function bufferKeysToClear(
  params: Record<AircraftBufferKey, string>,
  current: Pick<InventoryDrone, AircraftBufferKey>,
): AircraftBufferKey[] {
  const keys: AircraftBufferKey[] = ['geofence_buffer_m', 'obstacle_buffer_m'];
  return keys.filter((k) => params[k].trim() === '' && current[k] != null);
}
